import { MastraClient } from "@mastra/client-js";
import cookie from "react-cookies";

export const mastraClient = new MastraClient({
    baseUrl: import.meta.env.VITE_CINDRA_AGENT_URL || "http://localhost:4111"
});

// LLM ID type
export type LLMId = "claude-4-sonnet" | "gpt-5" | "gemini-2.5-pro";

// Cookie key for storing LLM selection
const LLM_SELECTION_COOKIE_KEY = "cindra_selected_llm";

// Default LLM ID
const DEFAULT_LLM_ID: LLMId = "gpt-5"; // Default to ChatGPT as requested

// Agent mapping
const agentMap: Record<LLMId, string> = {
    "gpt-5": "cindra-gpt",
    "claude-4-sonnet": "cindra-claude",
    "gemini-2.5-pro": "cindra-gemini"
};

// Function to get agent based on selected LLM
export const getAgentForLLM = (llmId: LLMId) => {
    const agentName = agentMap[llmId] || agentMap[DEFAULT_LLM_ID];
    return mastraClient.getAgent(agentName);
};

// Function to get the currently selected LLM ID from cookies
export const getSelectedLLM = (): LLMId => {
    const savedLLM = cookie.load(LLM_SELECTION_COOKIE_KEY) as LLMId | undefined;
    return savedLLM && agentMap[savedLLM] ? savedLLM : DEFAULT_LLM_ID;
};

// Function to save the selected LLM ID to cookies
export const setSelectedLLM = (llmId: LLMId): void => {
    // Save cookie with 1 year expiration
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    cookie.save(LLM_SELECTION_COOKIE_KEY, llmId, { path: "/", expires });
};

// Function to get the currently selected agent
export const getSelectedAgent = () => {
    const llmId = getSelectedLLM();
    return getAgentForLLM(llmId);
};

// Keep default export for backwards compatibility
export const cindraAgent = mastraClient.getAgent(agentMap[DEFAULT_LLM_ID]);
